import * as types from '../constants';
import { STATUS } from '../constants';
import { buildGetParamsObject, reject, resolve } from '../api';
import {
  defaultPagination,
  defaultFilters,
  defaultSorting,
  defaultFilterSettings,
  defaultSpecificFilterSettings,
  defaultExploreFilters,
  defaultExploreSorting,
} from '../constants/ioc';
import { updateSortOrder } from '../utils/ioc';
import Cookies from 'cookies-js';
import {
  showNotification,
  successNotification,
} from '../../shared-components/Notifications';
import _ from 'lodash';

export const initialIocListState = {
  pagination: {
    ...defaultPagination,
  },
  filters: {
    ...defaultFilters,
  },
  exploreFilters: {
    ...defaultExploreFilters,
  },
  exploreSorting: {
    ...defaultExploreSorting,
  },
  sorting: {
    ...defaultSorting,
  },
  feedStateFilter: 'Feed',
  sortOrder: ['-total'],
  distinct: false,
  filterProfile: null,
  iocList: null,
  filterEnabled: false,
  total: 0,
  status: STATUS.IDLE,
  exploreAPIDensityStatus: STATUS.IDLE,
  detailsStatus: STATUS.IDLE,
  infraTagStatus: STATUS.IDLE,
  domainInfraTags: null,
  deleteStatus: STATUS.IDLE,
  whoisStatus: STATUS.IDLE,
  whoisFallbackStatus: STATUS.IDLE,
  dnsRecordsStatus: STATUS.IDLE,
  filterSettings: defaultFilterSettings,
  specificFilterSettings: defaultSpecificFilterSettings,
  specificFilterSettingsStatus: STATUS.IDLE,
  tagOptions: [],
  tagOptionsStatus: STATUS.IDLE,
  recipeStatus: STATUS.IDLE,
  recipesStatus: STATUS.IDLE,
  schemasStatus: STATUS.IDLE,
  schemaStatus: STATUS.IDLE,
  exploreSchema: null,
  exploreSchemas: null,
  attackSurfaceMappingLeftMenuData: null,
  attackSurfaceMappingLeftMenuStatus: null,
  digitalThreatManagementLeftMenuData: null,
  digitalThreatManagementLeftMenuStatus: null,
  recipeStatusForwardA: STATUS.IDLE,
  recipeStatusNameServerChanges: STATUS.IDLE,
  recipeStatusTXT: STATUS.IDLE,
  recipeStatusIPDiversity: STATUS.IDLE,
  recipeStatusLatestDNSRecords: STATUS.IDLE,
  recipeStatusHostingInfrastructureASNs: STATUS.IDLE,
  recipeDataStatusHostingInfrastructureASNs: STATUS.IDLE,
  recipeStatusDanglingDNSRecordsCount: STATUS.IDLE,
  recipeDataStatusDanglingDNSRecordsCount: STATUS.IDLE,
  recipeStatusReverseA: STATUS.IDLE,
  recipeStatusDomainsOnServer: STATUS.IDLE,
  recipeStatusSubdomainFinder: STATUS.IDLE,
  recipeStatusShadowIT: STATUS.IDLE,
  recipeStatusSpoofing: STATUS.IDLE,
  recipeStatusNameInTXT: STATUS.IDLE,
  feedIOCListStatus: STATUS.IDLE,
  iocNotes: [],
  iocNotesStatus: STATUS.IDLE,
  stixDataStatus: STATUS.IDLE,
  parsedIOCStatus: STATUS.IDLE,
  iocNoteDeleting: false,
  runMonitorStatus: STATUS.IDLE,
  ASNAutoFillStatus: STATUS.IDLE,
};

function expireCookies() {
  const isExploreResultsPage = window.location.href.includes('/explore-result');
  return isExploreResultsPage ? '' : sessionStorage.removeItem('breadcrumbs');
}

export default (state = initialIocListState, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      expireCookies();

      let queryString = window.location.search;
      let urlParams = new URLSearchParams(queryString);

      return {
        ...state,
        ...((!window.location.href.includes('/explore-result') ||
          !urlParams.get('row')) && {
          filters: {
            ...defaultFilters,
          },
          exploreFilters: {
            ...defaultExploreFilters,
          },
          exploreSorting: {
            ...defaultExploreSorting,
          },
        }),
        filterProfile: null,
        infraTagStatus: STATUS.IDLE,
        domainInfraTags: null,
        sorting: {
          ...defaultSorting,
        },
      };

    case types.RESET_FILTER_PROFILE:
      return {
        ...state,
        filterProfile: null,
      };

    case types.RESET_ENRICHMENT_STATUS:
      return {
        ...state,
        mergeAPIEnrichment: {},
        enrichmentStatus: STATUS.IDLE,
        mergeAPINewEnrichment: {},
        mergeAPINewEnrichmentStatus: STATUS.IDLE,
        dnsRecords: {},
        dnsRecordsStatus: STATUS.IDLE,
        ARecordsDomainEnrichmentData: [],
        ARecordsDomainEnrichmentStatus: STATUS.IDLE,
        AAAARecordsDomainEnrichmentData: [],
        AAAARecordsDomainEnrichmentStatus: STATUS.IDLE,
        CNAMERecordsDomainEnrichmentData: [],
        CNAMERecordsDomainEnrichmentStatus: STATUS.IDLE,
        MXRecordsDomainEnrichmentData: [],
        MXRecordsDomainEnrichmentStatus: STATUS.IDLE,
        NSRecordsDomainEnrichmentData: [],
        NSRecordsDomainEnrichmentStatus: STATUS.IDLE,
        SOARecordsDomainEnrichmentData: [],
        SOARecordsDomainEnrichmentStatus: STATUS.IDLE,
        TXTRecordsDomainEnrichmentData: [],
        TXTRecordsDomainEnrichmentStatus: STATUS.IDLE,
        domainInfraTags: [],
        infraTagStatus: STATUS.IDLE,
        exploreAPIwhoisDetails: {},
        exploreAPIwhoisFallbackDetails: {},
        whoisStatus: STATUS.IDLE,
        whoisFallbackStatus: STATUS.IDLE,
        exploreAPIscoreDetails: {},
        ptrLookupEnrichmentStatus: STATUS.IDLE,
        ptrLookupEnrichment: {},
        ipDensityEnrichmentStatus: STATUS.IDLE,
        ipDensityEnrichment: {},
        parsedIOC: {},
        parsedIOCStatus: STATUS.IDLE,
      };

    case types.RESET_RECIPE_STATUS:
      return {
        ...state,
        recipesStatus: STATUS.IDLE,
        schemasStatus: STATUS.IDLE,
        schemaStatus: STATUS.IDLE,
        exploreSchema: null,
        //exploreSchemas: null,
        exploreRecipe: {},
        exploreRecipeSpoofing: {},
        exploreRecipeDomainsOnServer: {},
        exploreRecipeForwardA: {},
        exploreRecipeNameServerChanges: {},
        exploreRecipeSubdomainFinder: {},
        exploreRecipeShadowIT: {},
        exploreRecipeTXT: {},
        exploreRecipeIPDiversity: {},
        exploreRecipeLatestDNSRecords: {},
        exploreRecipeHostingInfrastructureASNs: {},
        exploreRecipeDataHostingInfrastructureASNs: [],
        exploreRecipeDanglingDNSRecordsCount: {},
        exploreRecipeDataDanglingDNSRecordsCount: [],
        exploreRecipeHostingInfraIPs: {},
        exploreRecipeDanglingDNSProtection: {},
        exploreRecipeDataDanglingDNSProtection: [],
        exploreRecipeNameInTXT: {},
        exploreRecipeReverseA: {},
        parsedIOC: {},
        parsedIOCStatus: STATUS.IDLE,
      };

    case types.RESET_ASN_AUTOFILL_STATUS:
      return {
        ...state,
        ASNAutoFillStatus: STATUS.IDLE,
        ASdata: [],
        ASNAutoFillData: [],
        selectedASrows: [],
        AStableKey: 0,
        searchedASstatus: false,
        preSelectASrowsNumber: 0,
        autoSelectASrows: false,
      };

    case resolve(types.UPDATE_IOC_NOTE):
      const updatedNote = action.payload;
      const idxToPutAt = state.iocNotes.findIndex(
        (note) => note.uuid === updatedNote.uuid,
      );
      const notes = state.iocNotes.slice();
      notes[idxToPutAt] = updatedNote;
      return {
        ...state,
        iocNotes: notes,
      };

    case resolve(types.CREATE_IOC_NOTE):
      const newNote = action.payload;
      return {
        ...state,
        iocNotes: [newNote, ...state.iocNotes],
      };
    case reject(types.CREATE_IOC_NOTE):
      return {
        ...state,
        error: true,
        status: STATUS.ERROR,
      };

    case types.DELETE_IOC_NOTE:
      return {
        ...state,
        iocNoteDeleting: true,
      };

    case resolve(types.DELETE_IOC_NOTE):
      const deletedNoteUUID = action.payload;
      return {
        ...state,
        iocNotes: state.iocNotes.filter((n) => n.uuid !== deletedNoteUUID),
        iocNoteDeleting: false,
      };

    case reject(types.DELETE_IOC_NOTE):
      return {
        ...state,
        error: true,
        status: STATUS.ERROR,
        iocNoteDeleting: false,
      };

    case types.LOAD_IOC_NOTES:
      return {
        ...state,
        iocNotesStatus: STATUS.LOADING,
        iocNotes: [],
      };

    case resolve(types.LOAD_IOC_NOTES):
      return {
        ...state,
        iocNotesStatus: STATUS.LOADED,
        iocNotes: [...action.payload],
      };

    case reject(types.LOAD_IOC_NOTES):
      return {
        ...state,
        iocNotesStatus: STATUS.ERROR,
        iocNotes: [],
        error: true,
        status: STATUS.ERROR,
      };

    case types.UPDATE_FILTER:
      return {
        ...state,
        filters: action?.filters,
      };

    case types.UPDATE_TAG:
      return {
        ...state,
        tag: action?.tag,
      };

    case types.UPDATE_SORTING:
      return {
        ...state,
        sorting: action?.sorting,
      };

    case types.UPDATE_PAGINATION:
      return {
        ...state,
        pagination: action?.pagination,
      };
    case types.UPDATE_DISTINCT:
      return {
        ...state,
        distinct: action?.distinct,
      };

    case types.UPDATE_IOC_LIST: {
      const newSortOrder = updateSortOrder(action?.sorting, state?.sorting);
      const endpointParams = buildGetParamsObject({
        pagination: action?.pagination,
        filters: action?.filters,
        sortOrder: newSortOrder,
        sorting: action?.sorting,
        filterProfile: action?.filterProfile,
        feed_state: action?.feed_state ?? 'Feed',
        tag: action?.tag,
      });
      const threatRankingEndpoint = Object?.keys(endpointParams)?.reduce(
        (prev, curr, idx) => {
          let connector = '?';
          if (idx > 0) connector = '&';
          return `${prev}${connector}${curr}=${endpointParams[curr]}`;
        },
        '/api/v2/iocs/threat-ranking/',
      );

      const pristineThreatRankingParams = {
        page: 1,
        limit: 100,
        distinct: false,
        order: '-total_ioc,-total_source_score',
        state: 'Feed',
      };

      let timeStampNow = new Date();
      //Only store the flag on un-touched "pristine" threat ranking
      if (_.isEqual(endpointParams, pristineThreatRankingParams)) {
        Cookies.expire('threat_ranking_cached_flag');
        timeStampNow.setSeconds(timeStampNow.getSeconds() + 300);
        // Storing in epoch time
      }

      return {
        ...state,
        ...(_.isEqual(endpointParams, pristineThreatRankingParams) &&
          !action.tag &&
          !state.tag && {
            threat_ranking_cached_flag: timeStampNow.getTime(),
            pristineThreatRanking: true,
          }),
        ...(!_.isEqual(endpointParams, pristineThreatRankingParams) &&
          !action.tag &&
          !state.tag && {
            // threat_ranking_cached_flag: timeStampNow.getTime(),
            pristineThreatRanking: false,
          }),
        status: STATUS.LOADING,
        filters: state?.filters,
        sorting:
          action?.sorting !== undefined ? action?.sorting : state?.sorting,
        distinct:
          action?.distinct !== undefined ? action?.distinct : state?.distinct,
        pagination:
          action?.pagination !== undefined
            ? action?.pagination
            : state?.pagination,
        filterProfile:
          action?.filterProfile !== undefined
            ? action?.filterProfile
            : state?.filterProfile,
        feed_state: action?.feed_state,
        sortOrder: newSortOrder,
        activeThreatRankingEndpoint: threatRankingEndpoint,
        endpointParams: endpointParams,
      };
    }
    case types.APPLY_FILTERS: {
      return {
        ...state,
        tag: null,
        status: STATUS.LOADING,
      };
    }
    case resolve(types.UPDATE_IOC_LIST):
      if (state.pristineThreatRanking === true && !state.tag) {
        localStorage.setItem(
          'threat_ranking_data',
          JSON?.stringify(action?.payload),
        );
      }
      // state.pristineThreatRanking ?
      // localStorage.setItem(
      //   'threat_ranking_data',
      //   JSON?.stringify(action?.payload)
      // )
      // : '';

      return {
        ...state,
        iocList: action?.payload,
        status: STATUS.LOADED,
        filterEnabled: false,
      };
    case reject(types.UPDATE_IOC_LIST):
      return {
        ...state,
        error: true,
        status: STATUS.ERROR,
      };

    case types.UPDATE_IOC_LIST_FROM_CACHE:
      const newSortOrder = updateSortOrder(action?.sorting, state?.sorting);
      const endpointParams = buildGetParamsObject({
        pagination: action?.pagination,
        filters: action?.filters,
        sortOrder: newSortOrder,
        sorting: action?.sorting,
        filterProfile: action?.filterProfile,
        feed_state: action?.feed_state ?? 'Feed',
        tag: action?.tag,
      });
      const threatRankingEndpoint = Object?.keys(endpointParams)?.reduce(
        (prev, curr, idx) => {
          let connector = '?';
          if (idx > 0) connector = '&';
          return `${prev}${connector}${curr}=${endpointParams[curr]}`;
        },
        '/api/v2/iocs/threat-ranking/',
      );
      return {
        ...state,
        status: STATUS.LOADING,
        filters: state?.filters,
        sorting:
          action?.sorting !== undefined ? action?.sorting : state?.sorting,
        distinct:
          action?.distinct !== undefined ? action?.distinct : state?.distinct,
        pagination:
          action?.pagination !== undefined
            ? action?.pagination
            : state?.pagination,
        filterProfile:
          action?.filterProfile !== undefined
            ? action?.filterProfile
            : state?.filterProfile,
        feed_state: action?.feed_state,
        sortOrder: newSortOrder,
        activeThreatRankingEndpoint: threatRankingEndpoint,
        endpointParams: endpointParams,
      };
    case resolve(types.UPDATE_IOC_LIST_FROM_CACHE):
      return {
        ...state,
        iocList: JSON?.parse(localStorage?.getItem('threat_ranking_data')),
        status: STATUS.LOADED,
        filterEnabled: false,
      };

    case types.PAGINATION_IOC_LIST: {
      const newSortOrder = updateSortOrder(action?.sorting, state?.sorting);

      return {
        ...state,
        paginationStatus: STATUS.LOADING,
        filters:
          action?.filters !== undefined ? action?.filters : state?.filters,
        sorting:
          action?.sorting !== undefined ? action?.sorting : state?.sorting,
        distinct:
          action?.distinct !== undefined ? action?.distinct : state?.distinct,
        pagination:
          action?.pagination !== undefined
            ? action?.pagination
            : state?.pagination,
        filterProfile:
          action?.filterProfile !== undefined
            ? action?.filterProfile
            : state?.filterProfile,
        feed_state: action?.feed_state,
        sortOrder: newSortOrder,
      };
    }

    case resolve(types.PAGINATION_IOC_LIST):
      if (state.pristineThreatRanking === true && !state.tag) {
        localStorage.setItem(
          'pagination_lazypagination',
          JSON?.stringify(action?.payload),
        );
        localStorage.setItem(
          'pagination_total',
          JSON?.stringify(action?.total),
        );
      }
      //       state.pristineThreatRanking ?
      //       (localStorage.setItem(
      //         'pagination_lazypagination',
      //         JSON?.stringify(action?.payload)
      //       ),
      //       localStorage.setItem('pagination_total', JSON?.stringify(action?.total)))
      // : '';
      return {
        ...state,
        lazyPagination: action?.payload,
        paginationStatus: STATUS.LOADED,
        filterEnabled: false,
        total: action?.total,
        next: action?.next,
        previous: action?.previous,
      };
    case reject(types.PAGINATION_IOC_LIST):
      return {
        ...state,
        error: true,
        paginationStatus: STATUS.ERROR,
      };

    case types.PAGINATION_IOC_LIST_FROM_CACHE: {
      const newSortOrder = updateSortOrder(action?.sorting, state?.sorting);

      return {
        ...state,
        paginationStatus: STATUS.LOADING,
        filters:
          action?.filters !== undefined ? action?.filters : state?.filters,
        sorting:
          action?.sorting !== undefined ? action?.sorting : state?.sorting,
        distinct:
          action?.distinct !== undefined ? action?.distinct : state?.distinct,
        pagination:
          action?.pagination !== undefined
            ? action?.pagination
            : state?.pagination,
        filterProfile:
          action?.filterProfile !== undefined
            ? action?.filterProfile
            : state?.filterProfile,
        feed_state: action?.feed_state,
        sortOrder: newSortOrder,
      };
    }

    case resolve(types.PAGINATION_IOC_LIST_FROM_CACHE):
      return {
        ...state,
        lazyPagination: JSON?.parse(
          localStorage?.getItem('pagination_lazypagination'),
        ),
        paginationStatus: STATUS.LOADED,
        filterEnabled: false,
        total: JSON?.parse(localStorage?.getItem('pagination_total')),
      };

    case types.RESET_STIX_EXPORT_LIMITED_STATUS:
      return {
        ...state,
        stix_data: [],
        stixDataStatus: STATUS.IDLE,
      };
    case types.EXPORT_LIST_TO_STIX_LIMITED:
      return {
        ...state,
        stix_data: [],
        stixDataStatus: STATUS.LOADING,
      };
    case resolve(types.EXPORT_LIST_TO_STIX_LIMITED):
      return {
        ...state,
        stix_data: action?.payload,
        stixDataStatus: STATUS.LOADED,
      };
    case reject(types.EXPORT_LIST_TO_STIX_LIMITED):
      return {
        ...state,
        error: true,
        stixDataStatus: STATUS.ERROR,
      };

    case types.FILTER_SWITCH:
      return {
        ...state,
        filterEnabled: action?.filterEnabled,
      };

    case types.CLEAR_SCORE_DETAILS:
      return {
        ...state,
        scoreDetails: { status: 'cleared' },
        iocNotes: [],
        iocNotesStatus: STATUS.IDLE,
      };
    case types.LOAD_SCORE_DETAILS:
      return {
        ...state,
        detailsStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_SCORE_DETAILS):
      return {
        ...state,
        scoreDetails: action?.payload,
        detailsStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_SCORE_DETAILS):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };
    case types.LOAD_NEW_SCORE_DETAILS:
      return {
        ...state,
        newDetailsStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_NEW_SCORE_DETAILS):
      return {
        ...state,
        newScoreDetails: action?.payload,
        newDetailsStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_NEW_SCORE_DETAILS):
      return {
        ...state,
        error: true,
        newDetailsStatus: STATUS.ERROR,
      };

    case resolve(types.LOAD_FILTERS): {
      return {
        ...state,
        filterSettings: action?.payload,
      };
    }

    case types.RESET_SPECIFIC_FILTER:
      return {
        ...state,
        specificFilterSettings: [],
        specificFilterSettingsStatus: STATUS.IDLE,
      };
    case types.LOAD_SPECIFIC_FILTER:
      return {
        ...state,
        specificFilterSettings: [],
        specificFilterSettingsStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_SPECIFIC_FILTER):
      return {
        ...state,
        specificFilterSettings: action?.payload,
        specificFilterSettingsStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_SPECIFIC_FILTER):
      return {
        ...state,
        error: true,
        specificFilterSettingsStatus: STATUS.ERROR,
      };

    case types.RESET_TAG_OPTIONS:
      return {
        ...state,
        tagOptions: [],
        tagOptionsStatus: STATUS.IDLE,
      };
    case types.LOAD_TAG_OPTIONS:
      return {
        ...state,
        tagOptions: [],
        tagOptionsStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_TAG_OPTIONS):
      return {
        ...state,
        tagOptions: action?.payload,
        tagOptionsStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_TAG_OPTIONS):
      return {
        ...state,
        error: true,
        tagOptionsStatus: STATUS.ERROR,
      };

    case types.AUTO_COMPLETE_TAG_OPTIONS:
      return {
        ...state,
        tagOptions: [],
        tagOptionsStatus: STATUS.LOADING,
      };
    case resolve(types.AUTO_COMPLETE_TAG_OPTIONS):
      return {
        ...state,
        tagOptions: action?.payload,
        tagOptionsStatus: STATUS.LOADED,
      };
    case reject(types.AUTO_COMPLETE_TAG_OPTIONS):
      return {
        ...state,
        error: true,
        tagOptionsStatus: STATUS.ERROR,
      };

    case types.CLEAR_EXPLORE_SCORE_DETAILS:
      return {
        ...state,
        parsedIOC: {},
        parsedIOCStatus: STATUS.IDLE,
        detailsStatus: STATUS.IDLE,
        exploreASNStatus: STATUS.IDLE,
        riskScoreStatus: STATUS.IDLE,
        exploreAPIscoreDetails: null,
        exploreRiskScores: [],
        exploreASNDetails: [],
        exploreFilters: {
          ...defaultExploreFilters,
        },
        exploreSorting: {
          ...defaultExploreSorting,
        },
      };
    case types.LOAD_MERGE_API_ENRICHMENT_SCORE_DETAILS:
      return {
        ...state,
        mergeAPIEnrichment: [],
        enrichmentStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_ENRICHMENT_SCORE_DETAILS):
      return {
        ...state,
        mergeAPIEnrichment: action?.payload,
        enrichmentStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_MERGE_API_ENRICHMENT_SCORE_DETAILS):
      return {
        ...state,
        error: true,
        enrichmentStatus: STATUS.ERROR,
      };

    case types.LOAD_MERGE_API_NEW_ENRICHMENT_SCORE_DETAILS:
      return {
        ...state,
        mergeAPINewEnrichment: [],
        mergeAPINewEnrichmentStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_NEW_ENRICHMENT_SCORE_DETAILS):
      return {
        ...state,
        mergeAPINewEnrichment: action?.payload,
        mergeAPINewEnrichmentStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_MERGE_API_NEW_ENRICHMENT_SCORE_DETAILS):
      return {
        ...state,
        error: true,
        mergeAPINewEnrichmentStatus: STATUS.ERROR,
      };

    case types.RESET_UTILS_PARSE_IOC_STATUS:
      return {
        ...state,
        parsedIOC: {},
        parsedIOCStatus: STATUS.IDLE,
      };
    case types.LOAD_UTILS_PARSE_IOC:
      return {
        ...state,
        parsedIOC: {},
        parsedIOCStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_UTILS_PARSE_IOC):
      return {
        ...state,
        parsedIOC: action?.payload,
        parsedIOCStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_UTILS_PARSE_IOC):
      return {
        ...state,
        error: true,
        parsedIOCStatus: STATUS.ERROR,
      };

    case types.LOAD_DNS_RECORDS:
      return {
        ...state,
        dnsRecords: [],
        dnsRecordsStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_DNS_RECORDS):
      return {
        ...state,
        dnsRecords: action?.payload,
        dnsRecordsStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_DNS_RECORDS):
      return {
        ...state,
        error: true,
        dnsRecordsStatus: STATUS.ERROR,
      };

    case types.LOAD_A_RECORDS_DOMAIN_ENRICHMENT:
      return {
        ...state,
        ARecordsDomainEnrichmentData: [],
        ARecordsDomainEnrichmentStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_A_RECORDS_DOMAIN_ENRICHMENT):
      return {
        ...state,
        ARecordsDomainEnrichmentData: action?.payload,
        ARecordsDomainEnrichmentStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_A_RECORDS_DOMAIN_ENRICHMENT):
      return {
        ...state,
        error: true,
        ARecordsDomainEnrichmentStatus: STATUS.ERROR,
      };

    case types.LOAD_AAAA_RECORDS_DOMAIN_ENRICHMENT:
      return {
        ...state,
        AAAARecordsDomainEnrichmentData: [],
        AAAARecordsDomainEnrichmentStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_AAAA_RECORDS_DOMAIN_ENRICHMENT):
      return {
        ...state,
        AAAARecordsDomainEnrichmentData: action?.payload,
        AAAARecordsDomainEnrichmentStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_AAAA_RECORDS_DOMAIN_ENRICHMENT):
      return {
        ...state,
        error: true,
        AAAARecordsDomainEnrichmentStatus: STATUS.ERROR,
      };

    case types.LOAD_CNAME_RECORDS_DOMAIN_ENRICHMENT:
      return {
        ...state,
        CNAMERecordsDomainEnrichmentData: [],
        CNAMERecordsDomainEnrichmentStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_CNAME_RECORDS_DOMAIN_ENRICHMENT):
      return {
        ...state,
        CNAMERecordsDomainEnrichmentData: action?.payload,
        CNAMERecordsDomainEnrichmentStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_CNAME_RECORDS_DOMAIN_ENRICHMENT):
      return {
        ...state,
        error: true,
        CNAMERecordsDomainEnrichmentStatus: STATUS.ERROR,
      };

    case types.LOAD_MX_RECORDS_DOMAIN_ENRICHMENT:
      return {
        ...state,
        MXRecordsDomainEnrichmentData: [],
        MXRecordsDomainEnrichmentStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_MX_RECORDS_DOMAIN_ENRICHMENT):
      return {
        ...state,
        MXRecordsDomainEnrichmentData: action?.payload,
        MXRecordsDomainEnrichmentStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_MX_RECORDS_DOMAIN_ENRICHMENT):
      return {
        ...state,
        error: true,
        MXRecordsDomainEnrichmentStatus: STATUS.ERROR,
      };

    case types.LOAD_NS_RECORDS_DOMAIN_ENRICHMENT:
      return {
        ...state,
        NSRecordsDomainEnrichmentData: [],
        NSRecordsDomainEnrichmentStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_NS_RECORDS_DOMAIN_ENRICHMENT):
      return {
        ...state,
        NSRecordsDomainEnrichmentData: action?.payload,
        NSRecordsDomainEnrichmentStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_NS_RECORDS_DOMAIN_ENRICHMENT):
      return {
        ...state,
        error: true,
        NSRecordsDomainEnrichmentStatus: STATUS.ERROR,
      };

    case types.LOAD_SOA_RECORDS_DOMAIN_ENRICHMENT:
      return {
        ...state,
        SOARecordsDomainEnrichmentData: [],
        SOARecordsDomainEnrichmentStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_SOA_RECORDS_DOMAIN_ENRICHMENT):
      return {
        ...state,
        SOARecordsDomainEnrichmentData: action?.payload,
        SOARecordsDomainEnrichmentStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_SOA_RECORDS_DOMAIN_ENRICHMENT):
      return {
        ...state,
        error: true,
        SOARecordsDomainEnrichmentStatus: STATUS.ERROR,
      };

    case types.LOAD_TXT_RECORDS_DOMAIN_ENRICHMENT:
      return {
        ...state,
        TXTRecordsDomainEnrichmentData: [],
        TXTRecordsDomainEnrichmentStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_TXT_RECORDS_DOMAIN_ENRICHMENT):
      return {
        ...state,
        TXTRecordsDomainEnrichmentData: action?.payload,
        TXTRecordsDomainEnrichmentStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_TXT_RECORDS_DOMAIN_ENRICHMENT):
      return {
        ...state,
        error: true,
        TXTRecordsDomainEnrichmentStatus: STATUS.ERROR,
      };

    case types.LOAD_IP_DENSITY:
      return {
        ...state,
        ipDensityEnrichment: [],
        ipDensityEnrichmentStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_IP_DENSITY):
      return {
        ...state,
        ipDensityEnrichment: action?.payload,
        ipDensityEnrichmentStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_IP_DENSITY):
      return {
        ...state,
        error: true,
        ipDensityEnrichmentStatus: STATUS.ERROR,
      };

    case types.LOAD_PTR_LOOKUP:
      return {
        ...state,
        ptrLookupEnrichment: [],
        ptrLookupEnrichmentStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_PTR_LOOKUP):
      return {
        ...state,
        ptrLookupEnrichment: action?.payload,
        ptrLookupEnrichmentStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_PTR_LOOKUP):
      return {
        ...state,
        error: true,
        ptrLookupEnrichmentStatus: STATUS.ERROR,
      };

    case types.LOAD_MONITORING_FILE:
      return {
        ...state,
      };
    case resolve(types.LOAD_MONITORING_FILE):
      return {
        ...state,
      };
    case reject(types.LOAD_MONITORING_FILE):
      return {
        ...state,
      };
    case types.LOAD_MONITORING_JSON_FILE:
      return {
        ...state,
        detailsStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_MONITORING_JSON_FILE):
      return {
        ...state,
        exploreAPIscoreDetails: action?.payload,
        detailsStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_MONITORING_JSON_FILE):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };
    case types.LOAD_RESULT_FILE:
      return {
        ...state,
        detailsStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_RESULT_FILE):
      return {
        ...state,
        exploreAPIscoreDetails: action?.payload,
        detailsStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_RESULT_FILE):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.LOAD_HISTORY_QUERIES:
      return {
        ...state,
        historyQueriesStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_HISTORY_QUERIES):
      return {
        ...state,
        historyQueries: action?.payload?.results,
        historyQueriesCount: action?.payload?.count,
        historyQueriesStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_HISTORY_QUERIES):
      return {
        ...state,
        error: true,
        historyQueriesStatus: STATUS.ERROR,
      };

    case types.LOAD_HISTORY_QUERY_RESULT:
      return {
        ...state,
        detailsStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_HISTORY_QUERY_RESULT):
      return {
        ...state,
        exploreAPIscoreDetails: action?.payload,
        detailsStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_HISTORY_QUERY_RESULT):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.CLEAR_COPY_HISTORY_QUERY_RESULT:
      return {
        ...state,
        queryHistoryResults: [],
        copyQueryHistoryResultStatus: STATUS.IDLE,
      };

    case types.COPY_HISTORY_QUERY_RESULT:
      return {
        ...state,
        copyQueryHistoryResultStatus: STATUS.LOADING,
      };
    case resolve(types.COPY_HISTORY_QUERY_RESULT): {
      let response = action?.payload;
      if (response?.status_code == 200) {
        response = response?.response;
        /**
         * Safari doesn't allow you programmatically interact with the clipboard
         * @see: https://developer.apple.com/forums/thread/691873
         */
        // navigator.clipboard.writeText(JSON.stringify(response));
      }
      return {
        ...state,
        queryHistoryResults: response,
        copyQueryHistoryResultStatus: STATUS.LOADED,
      };
    }
    case reject(types.COPY_HISTORY_QUERY_RESULT):
      return {
        ...state,
        error: true,
        copyQueryHistoryResultStatus: STATUS.ERROR,
      };

    case types.DOWNLOAD_HISTORY_QUERY_RESULT:
      return {
        ...state,
        downloadQueryHistoryResultStatus: STATUS.LOADING,
      };
    case resolve(types.DOWNLOAD_HISTORY_QUERY_RESULT): {
      return {
        ...state,
        downloadQueryHistoryResultStatus: STATUS.LOADED,
      };
    }
    case reject(types.DOWNLOAD_HISTORY_QUERY_RESULT):
      return {
        ...state,
        error: true,
        downloadQueryHistoryResultStatus: STATUS.ERROR,
      };

    case types.UPDATE_HISTORY_QUERY:
      return {
        ...state,
      };
    case resolve(types.UPDATE_HISTORY_QUERY):
      let indexInQueryHistoryTable = state?.historyQueries?.findIndex(
        (f) => f?.uuid === action?.payload?.uuid,
      );
      const updatedQuery = {
        ...state.historyQueries[indexInQueryHistoryTable],
        status: action?.payload?.status,
        total_results: action?.payload?.total_results,
      };
      return {
        ...state,
        historyQueries: [
          ...state.historyQueries.slice(0, indexInQueryHistoryTable),
          updatedQuery,
          ...state.historyQueries.slice(indexInQueryHistoryTable + 1),
        ],
      };
    case reject(types.UPDATE_HISTORY_QUERY):
      return {
        ...state,
      };

    case types.ADD_NEW_HISTORY_QUERY:
      return {
        ...state,
      };
    case resolve(types.ADD_NEW_HISTORY_QUERY):
      let checkIfFound = state?.historyQueries?.findIndex(
        (f) => f?.uuid === action?.payload?.uuid,
      );
      if (checkIfFound === -1) {
        let newQuery = {
          uuid: action?.payload?.uuid,
          url: action?.payload?.url,
          origin_label: action?.payload?.origin_label,
          origin_uid: action?.payload?.origin_uid,
          job_id: action?.payload?.job_id,
          total_results: action?.payload?.total_results,
          status: action?.payload?.status,
          is_enabled: action?.payload?.is_enabled,
          is_visualizable: action?.payload?.is_visualizable,
          created: action?.payload?.created,
          executed_by: action?.payload?.executed_by,
        };
        let newHistoryQueries = [newQuery, ...state.historyQueries];
        newHistoryQueries.pop();
        return {
          ...state,
          historyQueries: newHistoryQueries,
          historyQueriesCount: state?.historyQueriesCount + 1,
        };
      } else {
        return {
          ...state,
        };
      }

    case reject(types.ADD_NEW_HISTORY_QUERY):
      return {
        ...state,
      };

    case types.LOAD_MONITORING_QUERIES:
      return {
        ...state,
        monitoringQueriesStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_MONITORING_QUERIES):
      return {
        ...state,
        monitoringQueries: action?.payload?.results,
        monitoringQueriesCount: action?.payload?.count,
        monitoringQueriesStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_MONITORING_QUERIES):
      return {
        ...state,
        error: true,
        monitoringQueries: [],
        monitoringQueriesStatus: STATUS.ERROR,
        monitoringQueriesCount: 0,
      };
    case types.SAVE_MONITORING_QUERY:
      return {
        ...state,
        monitoringSaveStatus: STATUS.LOADING,
      };
    case resolve(types.SAVE_MONITORING_QUERY):
      return {
        ...state,
        monitoringSaveStatus: STATUS.LOADED,
      };
    case types.UPDATE_MONITORING_QUERY:
      return {
        ...state,
        updateMonitorStatus: STATUS.LOADING,
      };
    case resolve(types.UPDATE_MONITORING_QUERY): {
      const { monitoringQueries } = state;
      const i = monitoringQueries?.findIndex(
        (f) => f?.uuid === action?.payload?.uuid,
      );
      return {
        ...state,
        updateMonitorStatus: STATUS.LOADED,
        monitoringQueries: [
          ...state.monitoringQueries.slice(0, i),
          action?.payload,
          ...state.monitoringQueries.slice(i + 1),
        ],
      };
    }
    case reject(types.UPDATE_MONITORING_QUERY): {
      return {
        ...state,
        error: true,
        updateMonitorStatus: STATUS.LOADING,
        monitoringQueriesStatus: STATUS.ERROR,
      };
    }
    case types.DELETE_MONITORING_QUERY: {
      return {
        ...state,
      };
    }
    case resolve(types.DELETE_MONITORING_QUERY): {
      const { monitoringQueries } = state;
      const new_monitoring = monitoringQueries?.filter(
        (f) => f?.uuid !== action?.uuid,
      );
      return {
        ...state,
        monitoringQueries: new_monitoring,
      };
    }
    case reject(types.DELETE_MONITORING_QUERY):
      return {
        ...state,
        error: true,
      };

    case resolve(types.CHANGE_SCOPE_MONITORING_QUERY):
      let indexInMonitoringChangeScope = state?.monitoringQueries?.findIndex(
        (f) => f?.uuid === action?.payload?.uuid,
      );

      const updatedObj = {
        ...state.monitoringQueries[indexInMonitoringChangeScope],
        scope: action?.payload?.scope,
      };
      return {
        ...state,
        monitoringQueries: [
          ...state.monitoringQueries.slice(0, indexInMonitoringChangeScope),
          updatedObj,
          ...state.monitoringQueries.slice(indexInMonitoringChangeScope + 1),
        ],
      };

    case types.RUN_MONITORING_QUERY: {
      return {
        ...state,
        runMonitorStatus: STATUS.LOADING,
      };
    }
    case resolve(types.RUN_MONITORING_QUERY): {
      return {
        ...state,
        runMonitorStatus: STATUS.LOADED,
      };
    }
    case reject(types.RUN_MONITORING_QUERY):
      return {
        ...state,
        error: true,
        runMonitorStatus: STATUS.ERROR,
      };

    case types.LOAD_MONITORING_QUERY_RESULTS_HISTORY:
      return {
        ...state,
        monitoringQueryResultHistoryStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_MONITORING_QUERY_RESULTS_HISTORY):
      return {
        ...state,
        monitoringQueryResultHistories: action?.payload,
        monitoringQueryResultHistoryStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_MONITORING_QUERY_RESULTS_HISTORY):
      return {
        ...state,
        monitoringQueryResultHistoryStatus: STATUS.ERROR,
      };

    case types.LOAD_MERGE_API_DOMAIN_SCORE_DETAILS:
      return {
        ...state,
        detailsStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_DOMAIN_SCORE_DETAILS):
      return {
        ...state,
        mergeAPIscoreDetails: action?.payload,
        detailsStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_MERGE_API_DOMAIN_SCORE_DETAILS):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.LOAD_MERGE_API_IP_SCORE_DETAILS:
      return {
        ...state,
        detailsStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_IP_SCORE_DETAILS):
      return {
        ...state,
        mergeAPIscoreDetails: action?.payload,
        detailsStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_MERGE_API_IP_SCORE_DETAILS):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.LOAD_MERGE_API_RISK_SCORES:
      return {
        ...state,
        exploreRiskScores: [],
        riskScoreStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_RISK_SCORES):
      return {
        ...state,
        exploreRiskScores: action.payload,
        riskScoreStatus: STATUS.LOADED,
      };

    case types.LOAD_MERGE_API_ASN_DETAILS:
      return {
        ...state,
        exploreASNDetails: [],
        exploreASNStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_ASN_DETAILS):
      return {
        ...state,
        exploreASNDetails: action.payload,
        exploreASNStatus: STATUS.LOADED,
      };

    case types.LOAD_ATTACK_SURFACE_MAPPING:
      return {
        ...state,
        attackSurfaceMappingLeftMenuStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_ATTACK_SURFACE_MAPPING):
      return {
        ...state,
        attackSurfaceMappingLeftMenuData: action?.payload,
        attackSurfaceMappingLeftMenuStatus: STATUS.LOADED,
      };

    case types.LOAD_DIGITAL_THREAT_MANAGEMENT:
      return {
        ...state,
        digitalThreatManagementLeftMenuStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_DIGITAL_THREAT_MANAGEMENT):
      return {
        ...state,
        digitalThreatManagementLeftMenuData: action?.payload,
        digitalThreatManagementLeftMenuStatus: STATUS.LOADED,
      };

    case types.LOAD_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMAS:
      return {
        ...state,
        schemasStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMAS):
      return {
        ...state,
        exploreSchemas: action?.payload,
        schemasStatus: STATUS.LOADED,
      };

    case types.LOAD_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA:
      return {
        ...state,
        schemaStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA):
      return {
        ...state,
        exploreSchema: action?.payload,
        schemaStatus: STATUS.LOADED,
      };

    case resolve(types.DELETE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA):
      let indexInSchemas = state?.exploreSchemas?.form_list?.findIndex(
        (f) => f?.form_uuid === action?.uuid,
      );

      return {
        ...state,
        exploreSchemas: {
          form_list: [
            ...state?.exploreSchemas?.form_list?.slice(0, indexInSchemas),
            ...state?.exploreSchemas?.form_list?.slice(indexInSchemas + 1),
          ],
        },
        exploreSchema: null,
        schemaStatus: STATUS.IDLE,
      };

    case resolve(types.CHANGE_SCOPE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA):
      let indexInSchemasChangeScope = state?.exploreSchemas?.form_list?.findIndex(
        (f) => f?.form_uuid === action?.payload?.metadata?.form_uuid,
      );

      const newSchemaChangeScope = {
        form_name: action?.payload?.metadata?.form_name,
        form_description: action?.payload?.metadata?.form_description,
        form_uuid: action?.payload?.metadata?.form_uuid,
        form_parent_uuid: action?.payload?.metadata?.form_parent_uuid,
        scope: action?.payload?.scope,
      };

      return {
        ...state,
        exploreSchemas: {
          form_list: [
            ...state?.exploreSchemas?.form_list?.slice(
              0,
              indexInSchemasChangeScope,
            ),
            newSchemaChangeScope,
            ...state?.exploreSchemas?.form_list?.slice(
              indexInSchemasChangeScope + 1,
            ),
          ],
        },
      };

    case types.SAVE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA:
      return {
        ...state,
        schemasStatus: STATUS.LOADING,
      };
    case resolve(types.SAVE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA):
      const newSchema = {
        form_name: action?.payload?.metadata?.form_name,
        form_description: action?.payload?.metadata?.form_description,
        form_uuid: action?.payload?.metadata?.form_uuid,
        form_parent_uuid: action?.payload?.metadata?.form_parent_uuid,
        scope: action?.payload?.scope,
      };

      return {
        ...state,
        exploreSchemas: {
          form_list: [newSchema, ...state?.exploreSchemas?.form_list],
        },
        schemasStatus: STATUS.LOADED,
      };

    case types.LOAD_MERGE_API_EXPLORE_RECIPES:
      return {
        ...state,
        recipesStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_RECIPES):
      return {
        ...state,
        exploreRecipes: action?.payload,
        recipesStatus: STATUS.LOADED,
      };

    case types.LOAD_MERGE_API_EXPLORE_RECIPE:
      return {
        ...state,
        recipeStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_RECIPE):
      return {
        ...state,
        exploreRecipe: action?.payload,
        recipeStatus: STATUS.LOADED,
      };

    case types.LOAD_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS:
      return {
        ...state,
        recipeStatusHostingInfraIPs: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS):
      return {
        ...state,
        exploreRecipeHostingInfraIPs: action?.payload,
        recipeStatusHostingInfraIPs: STATUS.LOADED,
      };
    case types.SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS:
    case types.UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS:
      return {
        ...state,
        recipeStatus: STATUS.LOADING,
        recipeStatusHostingInfraIPs: STATUS.LOADING,
      };
    case resolve(types.SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS):
    case resolve(types.UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS):
      return {
        ...state,
        exploreRecipe: action?.payload,
        recipeStatus: STATUS.LOADED,
        exploreRecipeHostingInfraIPs: action?.payload,
        recipeStatusHostingInfraIPs: STATUS.LOADED,
      };
    case resolve(types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS):
      return {
        ...state,
        exploreRecipeHostingInfraIPs: action?.payload,
        recipeStatusHostingInfraIPs: STATUS.LOADED,
      };

    case types.LOAD_MERGE_API_EXPLORE_RECIPE_FORWARD_A:
      return {
        ...state,
        recipeStatusForwardA: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_RECIPE_FORWARD_A):
    case resolve(types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_FORWARD_A):
      return {
        ...state,
        exploreRecipeForwardA: action?.payload,
        recipeStatusForwardA: STATUS.LOADED,
      };
    case types.SAVE_MERGE_API_EXPLORE_RECIPE_FORWARD_A:
    case types.UPDATE_MERGE_API_EXPLORE_RECIPE_FORWARD_A:
      return {
        ...state,
        recipeStatus: STATUS.LOADING,
        recipeStatusForwardA: STATUS.LOADING,
      };
    case resolve(types.SAVE_MERGE_API_EXPLORE_RECIPE_FORWARD_A):
    case resolve(types.UPDATE_MERGE_API_EXPLORE_RECIPE_FORWARD_A):
      return {
        ...state,
        exploreRecipe: action?.payload,
        recipeStatus: STATUS.LOADED,
        exploreRecipeForwardA: action?.payload,
        recipeStatusForwardA: STATUS.LOADED,
      };

    case types.LOAD_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES:
      return {
        ...state,
        recipeStatusNameServerChanges: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES):
    case resolve(
      types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
    ):
      return {
        ...state,
        exploreRecipeNameServerChanges: action?.payload,
        recipeStatusNameServerChanges: STATUS.LOADED,
      };

    case types.SAVE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES:
    case types.UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES:
      return {
        ...state,
        recipeStatus: STATUS.LOADING,
        recipeStatusNameServerChanges: STATUS.LOADING,
      };
    case resolve(types.SAVE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES):
    case resolve(types.UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES):
      return {
        ...state,
        exploreRecipe: action?.payload,
        recipeStatus: STATUS.LOADED,
        exploreRecipeNameServerChanges: action?.payload,
        recipeStatusNameServerChanges: STATUS.LOADED,
      };

    case types.LOAD_MERGE_API_EXPLORE_RECIPE_TXT:
      return {
        ...state,
        recipeStatusTXT: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_RECIPE_TXT):
    case resolve(types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_TXT):
      return {
        ...state,
        exploreRecipeTXT: action?.payload,
        recipeStatusTXT: STATUS.LOADED,
      };

    case types.SAVE_MERGE_API_EXPLORE_RECIPE_TXT:
    case types.UPDATE_MERGE_API_EXPLORE_RECIPE_TXT:
      return {
        ...state,
        recipeStatus: STATUS.LOADING,
        recipeStatusTXT: STATUS.LOADING,
      };
    case resolve(types.SAVE_MERGE_API_EXPLORE_RECIPE_TXT):
    case resolve(types.UPDATE_MERGE_API_EXPLORE_RECIPE_TXT):
      return {
        ...state,
        exploreRecipe: action?.payload,
        recipeStatus: STATUS.LOADED,
        exploreRecipeTXT: action?.payload,
        recipeStatusTXT: STATUS.LOADED,
      };

    case types.LOAD_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY:
      return {
        ...state,
        recipeStatusIPDiversity: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY):
    case resolve(types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY):
      return {
        ...state,
        exploreRecipeIPDiversity: action?.payload,
        recipeStatusIPDiversity: STATUS.LOADED,
      };

    case types.SAVE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY:
    case types.UPDATE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY:
      return {
        ...state,
        recipeStatus: STATUS.LOADING,
        recipeStatusIPDiversity: STATUS.LOADING,
      };
    case resolve(types.SAVE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY):
    case resolve(types.UPDATE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY):
      return {
        ...state,
        exploreRecipe: action?.payload,
        recipeStatus: STATUS.LOADED,
        exploreRecipeIPDiversity: action?.payload,
        recipeStatusIPDiversity: STATUS.LOADED,
      };

    case types.LOAD_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS:
      return {
        ...state,
        recipeStatusLatestDNSRecords: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS):
    case resolve(
      types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS,
    ):
      return {
        ...state,
        exploreRecipeLatestDNSRecords: action?.payload,
        recipeStatusLatestDNSRecords: STATUS.LOADED,
      };

    case types.SAVE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS:
    case types.UPDATE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS:
      return {
        ...state,
        recipeStatus: STATUS.LOADING,
        recipeStatusLatestDNSRecords: STATUS.LOADING,
      };
    case resolve(types.SAVE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS):
    case resolve(types.UPDATE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS):
      return {
        ...state,
        exploreRecipe: action?.payload,
        recipeStatus: STATUS.LOADED,
        exploreRecipeLatestDNSRecords: action?.payload,
        recipeStatusLatestDNSRecords: STATUS.LOADED,
      };

    case types.LOAD_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS:
      return {
        ...state,
        recipeStatusHostingInfrastructureASNs: STATUS.LOADING,
      };
    case resolve(
      types.LOAD_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
    ):
    case resolve(
      types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
    ):
      return {
        ...state,
        exploreRecipeHostingInfrastructureASNs: action?.payload,
        recipeStatusHostingInfrastructureASNs: STATUS.LOADED,
      };

    case types.SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS:
    case types.UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS:
      return {
        ...state,
        recipeStatus: STATUS.LOADING,
        recipeStatusHostingInfrastructureASNs: STATUS.LOADING,
      };
    case resolve(
      types.SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
    ):
    case resolve(
      types.UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
    ):
      return {
        ...state,
        exploreRecipe: action?.payload,
        recipeStatus: STATUS.LOADED,
        exploreRecipeHostingInfrastructureASNs: action?.payload,
        recipeStatusHostingInfrastructureASNs: STATUS.LOADED,
      };

    case types.LOAD_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT:
      return {
        ...state,
        recipeStatusDanglingDNSRecordsCount: STATUS.LOADING,
      };
    case resolve(
      types.LOAD_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
    ):
    case resolve(
      types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
    ):
      return {
        ...state,
        exploreRecipeDanglingDNSRecordsCount: action?.payload,
        recipeStatusDanglingDNSRecordsCount: STATUS.LOADED,
      };

    case types.SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT:
    case types.UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT:
      return {
        ...state,
        recipeStatus: STATUS.LOADING,
        recipeStatusDanglingDNSRecordsCount: STATUS.LOADING,
      };
    case resolve(
      types.SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
    ):
    case resolve(
      types.UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
    ):
      return {
        ...state,
        exploreRecipe: action?.payload,
        recipeStatus: STATUS.LOADED,
        exploreRecipeDanglingDNSRecordsCount: action?.payload,
        recipeStatusDanglingDNSRecordsCount: STATUS.LOADED,
      };

    case types.LOAD_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION:
      return {
        ...state,
        recipeStatusDanglingDNSProtection: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION):
    case resolve(
      types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
    ):
      return {
        ...state,
        exploreRecipeDanglingDNSProtection: action?.payload,
        recipeStatusDanglingDNSProtection: STATUS.LOADED,
      };

    case types.SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION:
    case types.UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION:
      return {
        ...state,
        recipeStatus: STATUS.LOADING,
        recipeStatusDanglingDNSProtection: STATUS.LOADING,
      };
    case resolve(types.SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION):
    case resolve(types.UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION):
      return {
        ...state,
        exploreRecipe: action?.payload,
        recipeStatus: STATUS.LOADED,
        exploreRecipeDanglingDNSProtection: action?.payload,
        recipeStatusDanglingDNSProtection: STATUS.LOADED,
      };

    case types.LOAD_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER:
      return {
        ...state,
        recipeStatusSubdomainFinder: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER):
    case resolve(types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER):
      return {
        ...state,
        exploreRecipeSubdomainFinder: action?.payload,
        recipeStatusSubdomainFinder: STATUS.LOADED,
      };

    case types.SAVE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER:
    case types.UPDATE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER:
      return {
        ...state,
        recipeStatus: STATUS.LOADING,
        recipeStatusSubdomainFinder: STATUS.LOADING,
      };
    case resolve(types.SAVE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER):
    case resolve(types.UPDATE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER):
      return {
        ...state,
        exploreRecipe: action?.payload,
        recipeStatus: STATUS.LOADED,
        exploreRecipeSubdomainFinder: action?.payload,
        recipeStatusSubdomainFinder: STATUS.LOADED,
      };

    case types.LOAD_MERGE_API_EXPLORE_RECIPE_SHADOW_IT:
      return {
        ...state,
        recipeStatusShadowIT: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_RECIPE_SHADOW_IT):
    case resolve(types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT):
      return {
        ...state,
        exploreRecipeShadowIT: action?.payload,
        recipeStatusShadowIT: STATUS.LOADED,
      };

    case types.SAVE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT:
    case types.UPDATE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT:
      return {
        ...state,
        recipeStatus: STATUS.LOADING,
        recipeStatusShadowIT: STATUS.LOADING,
      };
    case resolve(types.SAVE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT):
    case resolve(types.UPDATE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT):
      return {
        ...state,
        exploreRecipe: action?.payload,
        recipeStatus: STATUS.LOADED,
        exploreRecipeShadowIT: action?.payload,
        recipeStatusShadowIT: STATUS.LOADED,
      };

    case types.LOAD_MERGE_API_EXPLORE_RECIPE_REVERSE_A:
      return {
        ...state,
        recipeStatusReverseA: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_RECIPE_REVERSE_A):
    case resolve(types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_REVERSE_A):
      return {
        ...state,
        exploreRecipeReverseA: action?.payload,
        recipeStatusReverseA: STATUS.LOADED,
      };

    case types.SAVE_MERGE_API_EXPLORE_RECIPE_REVERSE_A:
    case types.UPDATE_MERGE_API_EXPLORE_RECIPE_REVERSE_A:
      return {
        ...state,
        recipeStatus: STATUS.LOADING,
        recipeStatusReverseA: STATUS.LOADING,
      };
    case resolve(types.SAVE_MERGE_API_EXPLORE_RECIPE_REVERSE_A):
    case resolve(types.UPDATE_MERGE_API_EXPLORE_RECIPE_REVERSE_A):
      return {
        ...state,
        exploreRecipe: action?.payload,
        recipeStatus: STATUS.LOADED,
        exploreRecipeReverseA: action?.payload,
        recipeStatusReverseA: STATUS.LOADED,
      };

    case types.LOAD_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER:
      return {
        ...state,
        recipeStatusDomainsOnServer: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER):
    case resolve(types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER):
      return {
        ...state,
        exploreRecipeDomainsOnServer: action?.payload,
        recipeStatusDomainsOnServer: STATUS.LOADED,
      };

    case types.SAVE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER:
    case types.UPDATE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER:
      return {
        ...state,
        recipeStatus: STATUS.LOADING,
        recipeStatusDomainsOnServer: STATUS.LOADING,
      };
    case resolve(types.SAVE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER):
    case resolve(types.UPDATE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER):
      return {
        ...state,
        exploreRecipe: action?.payload,
        recipeStatus: STATUS.LOADED,
        exploreRecipeDomainsOnServer: action?.payload,
        recipeStatusDomainsOnServer: STATUS.LOADED,
      };

    case types.LOAD_MERGE_API_EXPLORE_RECIPE_SPOOFING:
      return {
        ...state,
        recipeStatusSpoofing: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_RECIPE_SPOOFING):
    case resolve(types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SPOOFING):
      return {
        ...state,
        exploreRecipeSpoofing: action?.payload,
        recipeStatusSpoofing: STATUS.LOADED,
      };

    case types.SAVE_MERGE_API_EXPLORE_RECIPE_SPOOFING:
      return {
        ...state,
        recipeStatus: STATUS.LOADING,
        recipeStatusSpoofing: STATUS.LOADING,
      };
    case resolve(types.SAVE_MERGE_API_EXPLORE_RECIPE_SPOOFING):
      return {
        ...state,
        exploreRecipe: action?.payload,
        recipeStatus: STATUS.LOADED,
        exploreRecipeSpoofing: action?.payload,
        recipeStatusSpoofing: STATUS.LOADED,
      };

    case types.UPDATE_MERGE_API_EXPLORE_RECIPE_SPOOFING:
      return {
        ...state,
        recipeStatus: STATUS.LOADING,
        recipeStatusSpoofing: STATUS.LOADING,
      };
    case resolve(types.UPDATE_MERGE_API_EXPLORE_RECIPE_SPOOFING):
      return {
        ...state,
        exploreRecipe: action?.payload,
        recipeStatus: STATUS.LOADED,
        exploreRecipeSpoofing: action?.payload,
        recipeStatusSpoofing: STATUS.LOADED,
      };

    case types.LOAD_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT:
      return {
        ...state,
        recipeStatusNameInTXT: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT):
    case resolve(types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT):
      return {
        ...state,
        exploreRecipeNameInTXT: action?.payload,
        recipeStatusNameInTXT: STATUS.LOADED,
      };

    case types.SAVE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT:
      return {
        ...state,
        recipeStatusNameInTXT: STATUS.LOADING,
      };
    case resolve(types.SAVE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT):
      return {
        ...state,
        exploreRecipeNameInTXT: action?.payload,
        recipeStatusNameInTXT: STATUS.LOADED,
      };

    case types.UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT:
      return {
        ...state,
        recipeStatusNameInTXT: STATUS.LOADING,
      };
    case resolve(types.UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT):
      return {
        ...state,
        exploreRecipeNameInTXT: action?.payload,
        recipeStatusNameInTXT: STATUS.LOADED,
      };

    case types.QUERY_NAME_IN_TXT_RECIPE:
      return {
        ...state,
        exploreAPIscoreDetails: [],
        detailsStatus: STATUS.LOADING,
        riskScoreStatus: STATUS.IDLE,
        exploreASNStatus: STATUS.IDLE,
        exploreFilters:
          action?.path?.exploreFilters !== undefined
            ? action?.path?.exploreFilters
            : state?.exploreFilters,
        exploreSorting:
          action?.path?.exploreSorting !== undefined
            ? action?.path?.exploreSorting
            : state?.exploreSorting,
        sorting:
          action?.path?.sorting !== undefined
            ? action?.path?.sorting
            : state?.sorting,
      };
    case resolve(types.QUERY_NAME_IN_TXT_RECIPE):
      return {
        ...state,
        exploreAPIscoreDetails: action?.payload,
        detailsStatus: STATUS.LOADED,
      };
    case reject(types.QUERY_NAME_IN_TXT_RECIPE):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.LOAD_MERGE_API_DOMAIN_INFRA_TAGS:
      return {
        ...state,
        infraTagStatus: STATUS.LOADING,
      };

    case resolve(types.LOAD_MERGE_API_DOMAIN_INFRA_TAGS):
      return {
        ...state,
        domainInfraTags: action?.payload,
        infraTagStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_MERGE_API_DOMAIN_INFRA_TAGS):
      return {
        ...state,
        error: true,
        infraTagStatus: STATUS.ERROR,
      };

    case types.LOAD_MERGE_API_EXPLORE_SCORE_DETAILS:
      return {
        ...state,
        exploreAPIscoreDetails: [],
        detailsStatus: STATUS.LOADING,
        riskScoreStatus: STATUS.IDLE,
        exploreASNStatus: STATUS.IDLE,
        exploreFilters:
          action?.path?.exploreFilters !== undefined
            ? action?.path?.exploreFilters
            : state?.exploreFilters,
        exploreSorting:
          action?.path?.exploreSorting !== undefined
            ? action?.path?.exploreSorting
            : state?.exploreSorting,
        sorting:
          action?.path?.sorting !== undefined
            ? action?.path?.sorting
            : state?.sorting,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_SCORE_DETAILS):
      return {
        ...state,
        exploreAPIscoreDetails: action?.payload,
        detailsStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_MERGE_API_EXPLORE_SCORE_DETAILS):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.LOAD_HOSTING_INFRASTRUCTURE_ASN_DATA:
      return {
        ...state,
        recipeDataStatusHostingInfrastructureASNs: STATUS.LOADING,
        exploreRecipeDataHostingInfrastructureASNs: [],
      };
    case resolve(types.LOAD_HOSTING_INFRASTRUCTURE_ASN_DATA):
      return {
        ...state,
        recipeDataStatusHostingInfrastructureASNs: STATUS.LOADED,
        exploreRecipeDataHostingInfrastructureASNs: action.payload,
      };
    case reject(types.LOAD_HOSTING_INFRASTRUCTURE_ASN_DATA):
      return {
        ...state,
        error: true,
        recipeDataStatusHostingInfrastructureASNs: STATUS.ERROR,
      };

    case types.LOAD_DANGLING_DNS_RECORDS_COUNT_DATA:
      return {
        ...state,
        recipeDataStatusDanglingDNSRecordsCount: STATUS.LOADING,
        exploreRecipeDataDanglingDNSRecordsCount: [],
      };
    case resolve(types.LOAD_DANGLING_DNS_RECORDS_COUNT_DATA):
      return {
        ...state,
        recipeDataStatusDanglingDNSRecordsCount: STATUS.LOADED,
        exploreRecipeDataDanglingDNSRecordsCount: action.payload,
      };
    case reject(types.LOAD_DANGLING_DNS_RECORDS_COUNT_DATA):
      return {
        ...state,
        error: true,
        recipeDataStatusDanglingDNSRecordsCount: STATUS.ERROR,
      };

    case types.LOAD_DANGLING_DNS_PROTECTION_DATA:
      return {
        ...state,
        recipeDataStatusDanglingDNSProtection: STATUS.LOADING,
        exploreRecipeDataDanglingDNSProtection: [],
      };
    case resolve(types.LOAD_DANGLING_DNS_PROTECTION_DATA):
      return {
        ...state,
        recipeDataStatusDanglingDNSProtection: STATUS.LOADED,
        exploreRecipeDataDanglingDNSProtection: action.payload,
      };
    case reject(types.LOAD_DANGLING_DNS_PROTECTION_DATA):
      return {
        ...state,
        error: true,
        recipeDataStatusDanglingDNSProtection: STATUS.ERROR,
      };

    case types.LOAD_NAME_SERVER_AUTOFILL:
      return {
        ...state,
        nameServerAutoFillStatus: STATUS.LOADING,
        nameServerAutoFillData: [],
      };
    case resolve(types.LOAD_NAME_SERVER_AUTOFILL):
      return {
        ...state,
        //exploreAPIscoreDetails: action?.payload,
        nameServerAutoFillData: action?.payload,
        nameServerAutoFillStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_NAME_SERVER_AUTOFILL):
      return {
        ...state,
        error: true,
        nameServerAutoFillStatus: STATUS.ERROR,
      };

    case types.LOAD_ASN_AUTOFILL:
      return {
        ...state,
        ASNAutoFillStatus: STATUS.LOADING,
        ASNAutoFillData: [],
      };
    case resolve(types.LOAD_ASN_AUTOFILL):
      return {
        ...state,
        //exploreAPIscoreDetails: action?.payload,
        ASNAutoFillData: action?.payload,
        ASNAutoFillStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_ASN_AUTOFILL):
      return {
        ...state,
        error: true,
        ASNAutoFillStatus: STATUS.ERROR,
      };

    case types.POST_MERGE_API_EXPLORE_SCORE_DETAILS:
      return {
        ...state,
        detailsStatus: STATUS.LOADING,
        exploreFilters:
          action?.path?.exploreFilters !== undefined
            ? action?.path?.exploreFilters
            : state?.exploreFilters,
        exploreSorting:
          action?.path?.exploreSorting !== undefined
            ? action?.path?.exploreSorting
            : state?.exploreSorting,
        sorting:
          action?.path?.sorting !== undefined
            ? action?.path?.sorting
            : state?.sorting,
      };
    case resolve(types.POST_MERGE_API_EXPLORE_SCORE_DETAILS):
      return {
        ...state,
        exploreAPIscoreDetails: action?.payload,
        detailsStatus: STATUS.LOADED,
      };
    case reject(types.POST_MERGE_API_EXPLORE_SCORE_DETAILS):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.LOAD_MERGE_API_MERGE_SCORE_DETAILS:
      return {
        ...state,
        detailsStatus: STATUS.LOADING,
        exploreFilters:
          action?.path?.exploreFilters !== undefined
            ? action?.path?.exploreFilters
            : state?.exploreFilters,
        exploreSorting:
          action?.path?.exploreSorting !== undefined
            ? action?.path?.exploreSorting
            : state?.exploreSorting,
        sorting:
          action?.path?.sorting !== undefined
            ? action?.path?.sorting
            : state?.sorting,
      };
    case resolve(types.LOAD_MERGE_API_MERGE_SCORE_DETAILS):
      return {
        ...state,
        mergeAPIData: action?.payload,
        detailsStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_MERGE_API_MERGE_SCORE_DETAILS):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.POST_MERGE_API_MERGE_SCORE_DETAILS:
      return {
        ...state,
        detailsStatus: STATUS.LOADING,
        exploreFilters:
          action?.path?.exploreFilters !== undefined
            ? action?.path?.exploreFilters
            : state?.exploreFilters,
        exploreSorting:
          action?.path?.exploreSorting !== undefined
            ? action?.path?.exploreSorting
            : state?.exploreSorting,
        sorting:
          action?.path?.sorting !== undefined
            ? action?.path?.sorting
            : state?.sorting,
      };
    case resolve(types.POST_MERGE_API_MERGE_SCORE_DETAILS):
      return {
        ...state,
        mergeAPIData: action?.payload,
        detailsStatus: STATUS.LOADED,
      };
    case reject(types.POST_MERGE_API_MERGE_SCORE_DETAILS):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.LOAD_MERGE_API_EXPLORE_ANYIP_SCORE_DETAILS:
      return {
        ...state,
        detailsStatus: STATUS.LOADING,
        exploreFilters:
          action?.path1?.exploreFilters !== undefined
            ? action?.path1?.exploreFilters
            : state?.exploreFilters,
        exploreSorting:
          action?.path1?.exploreSorting !== undefined
            ? action?.path1?.exploreSorting
            : state?.exploreSorting,
        sorting:
          action?.path1?.sorting !== undefined
            ? action?.path1?.sorting
            : state?.sorting,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_ANYIP_SCORE_DETAILS):
      return {
        ...state,
        exploreAPIANYIPscoreDetails: action?.payload,
        exploreAPIANYIPJobID: action?.jobID,
        detailsStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_MERGE_API_EXPLORE_ANYIP_SCORE_DETAILS):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };
    case types.LOAD_MERGE_API_EXPLORE_IP_DENSITY_DETAILS:
      return {
        ...state,
        ipDensityStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_IP_DENSITY_DETAILS):
      return {
        ...state,
        exploreAPIIPDensityDetails: action?.payload,
        ipDensityStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_MERGE_API_EXPLORE_IP_DENSITY_DETAILS):
      return {
        ...state,
        error: true,
        ipDensityStatus: STATUS.ERROR,
      };

    case types.LOAD_MERGE_API_EXPLORE_DENSITY_DETAILS:
      return {
        ...state,
        exploreAPIDensityStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_DENSITY_DETAILS):
      return {
        ...state,
        exploreAPIDensityDetails: action?.payload,
        exploreAPIDensityStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_MERGE_API_EXPLORE_DENSITY_DETAILS):
      return {
        ...state,
        error: true,
        exploreAPIDensityStatus: STATUS.ERROR,
      };
    case types.LOAD_MERGE_API_EXPLORE_WHOIS_DETAILS:
      return {
        ...state,
        whoisStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_WHOIS_DETAILS):
      return {
        ...state,
        exploreAPIwhoisDetails: action?.payload,
        whoisStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_MERGE_API_EXPLORE_WHOIS_DETAILS):
      return {
        ...state,
        error: true,
        whoisStatus: STATUS.ERROR,
      };

    case types.LOAD_MERGE_API_EXPLORE_WHOIS_FALLBACK_DETAILS:
      return {
        ...state,
        whoisFallbackStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_MERGE_API_EXPLORE_WHOIS_FALLBACK_DETAILS):
      return {
        ...state,
        exploreAPIwhoisFallbackDetails: action?.payload,
        whoisFallbackStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_MERGE_API_EXPLORE_WHOIS_FALLBACK_DETAILS):
      return {
        ...state,
        error: true,
        whoisFallbackStatus: STATUS.ERROR,
      };

    case resolve(types.TOGGLE_FALSE_POSITIVE): {
      return {
        ...state,
        scoreDetails: action?.payload,
      };
    }
    case resolve(types.TOGGLE_TRUE_POSITIVE): {
      return {
        ...state,
        scoreDetails: action?.payload,
      };
    }
    case resolve(types.ADD_IOC_TAG):
    case resolve(types.REMOVE_IOC_TAG): {
      return {
        ...state,
        scoreDetails: {
          ...state?.scoreDetails,
          ...action?.payload,
        },
      };
    }

    case types.CREATE_IOC:
      return {
        ...state,
      };
    case resolve(types.CREATE_IOC):
      return {
        ...state,
        mergeAPIscoreDetails: action?.payload,
        detailsStatus: STATUS.LOADED,
      };
    case types.DELETE_IOC:
      return {
        ...state,
        deleteStatus: STATUS.LOADING,
      };
    case resolve(types.DELETE_IOC):
      const { iocList } = state;
      const index = iocList?.findIndex(
        (f) => f?.uuid === action?.payload?.ioc_uuid,
      );
      return {
        ...state,
        iocList: [...iocList?.slice(0, index), ...iocList?.slice(index + 1)],
        detailsStatus: STATUS.LOADED,
        deleteStatus: STATUS.LOADED,
        total: state?.total - 1,
      };

    case types.DELETE_IOC_FROM_COLLECTION:
      return {
        ...state,
      };
    case resolve(types.DELETE_IOC_FROM_COLLECTION):
      const { feedIOCList } = state;
      const indexInCollection = feedIOCList?.findIndex(
        (f) => f?.uuid === action?.payload?.ioc_uuid,
      );

      return {
        ...state,
        feedIOCList: [
          ...feedIOCList?.slice(0, indexInCollection),
          ...feedIOCList?.slice(indexInCollection + 1),
        ],
      };

    case types.LOAD_IOCS_FROM_SPECIFIC_COLLECTION:
      return {
        ...state,
        feedIOCListStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_IOCS_FROM_SPECIFIC_COLLECTION):
      return {
        ...state,
        feedIOCListCount: action?.payload?.count,
        feedIOCList: action?.payload?.results,
        feedIOCListStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_IOCS_FROM_SPECIFIC_COLLECTION):
      return {
        ...state,
        feedIOCList: action?.payload?.results,
        feedIOCListStatus: STATUS.ERROR,
      };

    case types.LOAD_IOCS_PAGE_FROM_SPECIFIC_COLLECTION:
      return {
        ...state,
        feedIOCListStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_IOCS_PAGE_FROM_SPECIFIC_COLLECTION):
      return {
        ...state,
        feedIOCListCount: action?.payload?.count,
        feedIOCList: action?.payload?.results,
        feedIOCListStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_IOCS_PAGE_FROM_SPECIFIC_COLLECTION):
      return {
        ...state,
        feedIOCList: action?.payload?.results,
        feedIOCListStatus: STATUS.ERROR,
      };

    case types.LOAD_IOCS_FROM_SPECIFIC_SHARED_COLLECTION:
      return {
        ...state,
        sharedFeedIOCListStatus: STATUS.RUNNING,
      };
    case resolve(types.LOAD_IOCS_FROM_SPECIFIC_SHARED_COLLECTION):
      return {
        ...state,
        sharedFeedIOCList: action?.payload?.results,
        sharedFeedIOCListStatus: STATUS.LOADED,
      };

    case types.SAVE_BREADCRUMBS:
      return {
        ...state,
      };
    case resolve(types.SAVE_BREADCRUMBS):
      return {
        ...state,
        breadcrumbs: action?.payload,
      };

    case types.SET_FEED_STATE_FILTER: {
      return {
        ...state,
        feedStateFilter: action?.data,
      };
    }

    case types.LOAD_BRAND_IMPERSONATION_RECIPE_RESULTS:
      return {
        ...state,
        exploreAPIscoreDetails: [],
        detailsStatus: STATUS.LOADING,
        riskScoreStatus: STATUS.IDLE,
        exploreASNStatus: STATUS.IDLE,
        exploreFilters:
          action?.path?.exploreFilters !== undefined
            ? action?.path?.exploreFilters
            : state?.exploreFilters,
        exploreSorting:
          action?.path?.exploreSorting !== undefined
            ? action?.path?.exploreSorting
            : state?.exploreSorting,
        sorting:
          action?.path?.sorting !== undefined
            ? action?.path?.sorting
            : state?.sorting,
      };
    case resolve(types.LOAD_BRAND_IMPERSONATION_RECIPE_RESULTS):
      return {
        ...state,
        exploreAPIscoreDetails: action?.payload,
        detailsStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_BRAND_IMPERSONATION_RECIPE_RESULTS):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.LOAD_HOSTING_INFRASTRUCTURE_ASNS_RECIPE_RESULTS:
    case types.LOAD_DANGLING_DNS_DETECTION_RECIPE_RESULTS:
    case types.LOAD_HOSTING_INFRASTRUCTURE_IPS_RECIPE_RESULTS:
    case types.LOAD_SHADOW_IT_RECIPE_RESULTS:
    case types.LOAD_SUBDOMAIN_FINDER_RECIPE_RESULTS:
      return {
        ...state,
        exploreAPIscoreDetails: [],
        detailsStatus: STATUS.LOADING,
        riskScoreStatus: STATUS.IDLE,
        exploreASNStatus: STATUS.IDLE,
        exploreFilters:
          action?.path?.exploreFilters !== undefined
            ? action?.path?.exploreFilters
            : state?.exploreFilters,
        exploreSorting:
          action?.path?.exploreSorting !== undefined
            ? action?.path?.exploreSorting
            : state?.exploreSorting,
        sorting:
          action?.path?.sorting !== undefined
            ? action?.path?.sorting
            : state?.sorting,
      };
    case resolve(types.LOAD_HOSTING_INFRASTRUCTURE_ASNS_RECIPE_RESULTS):
    case resolve(types.LOAD_DANGLING_DNS_DETECTION_RECIPE_RESULTS):
    case resolve(types.LOAD_HOSTING_INFRASTRUCTURE_IPS_RECIPE_RESULTS):
    case resolve(types.LOAD_SHADOW_IT_RECIPE_RESULTS):
    case resolve(types.LOAD_SUBDOMAIN_FINDER_RECIPE_RESULTS):
      return {
        ...state,
        exploreAPIscoreDetails: action?.payload,
        detailsStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_HOSTING_INFRASTRUCTURE_ASNS_RECIPE_RESULTS):
    case reject(types.LOAD_DANGLING_DNS_DETECTION_RECIPE_RESULTS):
    case reject(types.LOAD_HOSTING_INFRASTRUCTURE_IPS_RECIPE_RESULTS):
    case reject(types.LOAD_SHADOW_IT_RECIPE_RESULTS):
    case reject(types.LOAD_SUBDOMAIN_FINDER_RECIPE_RESULTS):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.SET_CLEAR_RECIPE:
      return {
        ...state,
        clearRecipe: true,
      };

    case types.UNSET_CLEAR_RECIPE:
      return {
        ...state,
        clearRecipe: false,
      };

    default:
      return state;
  }
};
